import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "ms-3 d-flex align-items-center" }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAction('Fissa chiamata 1', 'call', '', true, '1° chiamata')))
      }, [
        _cache[10] || (_cache[10] = _createElementVNode("div", null, [
          _createElementVNode("i", { class: "fa fa-phone fa-2x" })
        ], -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "1° chiamata",
            text: "1° chiamata"
          })
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openAction('Fissa chiamata 2', 'call', '', true, '2° chiamata')))
      }, [
        _cache[11] || (_cache[11] = _createElementVNode("div", null, [
          _createElementVNode("i", { class: "fa fa-phone fa-2x" })
        ], -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "2° chiamata",
            text: "2° chiamata"
          })
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openAction('Fissa chiamata 3', 'call', '', true, '3° chiamata')))
      }, [
        _cache[12] || (_cache[12] = _createElementVNode("div", null, [
          _createElementVNode("i", { class: "fa fa-phone fa-2x" })
        ], -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "3° chiamata",
            text: "3° chiamata"
          })
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openAction('Fissa chiamata X', 'call', '', true, 'Altre chiamate')))
      }, [
        _cache[13] || (_cache[13] = _createElementVNode("div", null, [
          _createElementVNode("i", { class: "fa fa-phone fa-2x" })
        ], -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Altre chiamate",
            text: "Altre chiamate"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openAction('Fissa WhatsApp 1', 'whatsapp', '', true, '1° WhatsApp')))
      }, [
        _cache[14] || (_cache[14] = _createElementVNode("div", null, [
          _createElementVNode("i", { class: "fa fa-whatsapp fa-2x" })
        ], -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "1° WhatsApp",
            text: "1° WhatsApp"
          })
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openAction('Fissa WhatsApp 2', 'whatsapp', '', true, '2° WhatsApp')))
      }, [
        _cache[15] || (_cache[15] = _createElementVNode("div", null, [
          _createElementVNode("i", { class: "fa fa-whatsapp fa-2x" })
        ], -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "2° WhatsApp",
            text: "2° WhatsApp"
          })
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openAction('Fissa WhatsApp 3', 'whatsapp', '', true, '3° WhatsApp')))
      }, [
        _cache[16] || (_cache[16] = _createElementVNode("div", null, [
          _createElementVNode("i", { class: "fa fa-whatsapp fa-2x" })
        ], -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "3° WhatsApp",
            text: "3° WhatsApp"
          })
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openAction('Fissa WhatsApp X', 'whatsapp', '', true, 'Altre WhatsApp')))
      }, [
        _cache[17] || (_cache[17] = _createElementVNode("div", null, [
          _createElementVNode("i", { class: "fa fa-whatsapp fa-2x" })
        ], -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Altre WhatsApp",
            text: "Altre WhatsApp"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "checkBig",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isChiamato) = $event)),
            onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.setChiamato && _ctx.setChiamato(...args))),
            disabled: _ctx.isChiamato && !_ctx.$store.state.isAdmin()
          }, null, 40, _hoisted_5), [
            [_vModelCheckbox, _ctx.isChiamato]
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "ms-1" }, "Chiamato", -1))
        ])
      ])
    ])
  ], 64))
}